import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
interface Condition {
  icon: LucideIcon;
  title: string;
  description: string | string[];
}
interface InsuranceConditionsProps {
  conditions: Condition[];
}
const InsuranceConditions = ({
  conditions
}: InsuranceConditionsProps) => {
  return <section className="py-16 sm:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8 lg:mb-10">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2 sm:mb-3">
            Versicherungskonditionen
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground">
            Transparente Übersicht aller wichtigen Details
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {conditions.map((condition, index) => {
          const Icon = condition.icon;
          return <div key={index} className="premium-card p-6 !border-transparent">
              <div className="flex flex-col lg:flex-row items-center lg:items-start gap-4">
                <Icon className="premium-card-icon" />
                <div className="flex-1 text-center lg:text-left">
                  <h3 className="premium-card-title mb-3">{condition.title}</h3>
                  {Array.isArray(condition.description) ? (
                    <ul className="space-y-2">
                      {condition.description.map((item, idx) => (
                        <li key={idx} className="flex items-start gap-2 premium-card-description">
                          <span className="text-accent mt-1 flex-shrink-0">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="premium-card-description">
                      {condition.description}
                    </p>
                  )}
                </div>
              </div>
            </div>;
        })}
        </div>
      </div>
    </section>;
};
export default InsuranceConditions;